// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__3gS1J","more":"styles_more__1-c3w"};